import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/ui/page-header";
import { TenantOnboardingWizard } from "@/components/tenants/TenantOnboardingWizard";
import { TenantFormData } from "@/types/tenant";
import { useTenants } from "@/hooks/useTenants";
import { useCompactMode } from "@/hooks/useCompactMode";

export default function OnboardTenantPage() {
  const navigate = useNavigate();
  const { createTenant, isCreating } = useTenants();
  const { cx } = useCompactMode();

  const handleComplete = async (data: TenantFormData) => {
    await createTenant(data);
    navigate("/admin/tenants");
  };

  return (
    <div className={cx("px-6 py-6 space-y-6", "px-6 py-4 space-y-4")}>
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate("/admin/tenants")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <PageHeader title="Onboard New Customer" description="Add a new customer tenant to your partner account" />
      </div>

      {/* Wizard */}
      <TenantOnboardingWizard 
        onComplete={handleComplete}
        isSubmitting={isCreating}
      />
    </div>
  );
}
